
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

export default function Hero() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative h-screen overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out"
        style={{ 
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/5f6724420124644bdf14d1fd7299b035.jpg)',
          transform: isVisible ? 'scale(1)' : 'scale(1.1)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-center">
        <div className="max-w-[1400px] mx-auto px-8 w-full">
          <div className="max-w-3xl">
            <h1 
              className={`text-6xl md:text-7xl lg:text-8xl font-light text-white mb-8 leading-tight tracking-tight transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: '200ms' }}
            >
              {t('hero.title')}<br />{t('hero.titleLine2')}
            </h1>
            <p 
              className={`text-lg md:text-xl text-white/90 mb-12 leading-relaxed font-light max-w-2xl transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: '400ms' }}
            >
              {t('hero.description')}
            </p>
            <Link
              to="/contact"
              className={`inline-block px-10 py-4 bg-white text-gray-900 text-sm font-medium tracking-widest hover:bg-gray-100 transition-all duration-300 whitespace-nowrap hover:scale-105 hover:shadow-lg ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: '600ms' }}
            >
              {t('hero.cta')}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
